module.exports = __webpack_public_path__ + "static/media/menu-security.1310372b.svg";